import { render, staticRenderFns } from "./RecurringPaymentsProductSettingChange.vue?vue&type=template&id=31f6e920&"
import script from "./RecurringPaymentsProductSettingChange.vue?vue&type=script&lang=ts&"
export * from "./RecurringPaymentsProductSettingChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports